import getNextCityCode from './getNextCityCode'
import getCityDataByCode from './getCityDataByCode'

import { getCityCode } from './storageCityCode'

export default async function () {
  let cityCode;

  try {
    cityCode = await getCityCode();
    return await getCityDataByCode(cityCode)
  }catch (e) {
    try {

      cityCode = await getNextCityCode();

      return await getCityDataByCode(cityCode)

    }catch (e) { throw e }
  }
}
